import { render, staticRenderFns } from "./form-cadastro.vue?vue&type=template&id=ae915b64"
import script from "./form-cadastro.vue?vue&type=script&lang=js"
export * from "./form-cadastro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports